import gql from 'graphql-tag';

const NewCourseMutation = gql`
  mutation NewCourse($courseName: String!, $sessionId: String!) {
    createCourse(name: $courseName, sessionId: $sessionId) {
      course {
        id
      }
      location
      result {
        success
        status
        errors {
          title
          message
        }
      }
    }
  }
`;

export default NewCourseMutation;
